import { downloadFile } from "./downloadFile.js";

export function formatNumberForCsv(value: number | string): string {
  const num = typeof value === "string" ? parseFloat(value.replace(",", ".")) : value;
  if (isNaN(num)) return value.toString();
  return num.toString().replace(".", ",");
}

function convertToCSV(rows: string[][]): string {
  return "\uFEFF" + rows.map((e) => e.join(";")).join("\n");
}

export function downloadCsv(rows: string[][], fileName: string) {
  downloadFile(convertToCSV(rows), fileName, "text/csv");
}
